import "./App.css";
import AttendanceForm from "./components/AttendanceForm";

function App() {
  return (
    <div className="App">
      <AttendanceForm />
    </div>
  );
}

export default App;
